// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportView_wrapper__Ef95q","title":"SupportView_title__aIhXV","content":"SupportView_content__3iwHb"};